import { __rest } from "tslib";
import * as React from 'react';
import { useState, useMemo, useEffect } from 'react';
import RcCascader from 'rc-cascader';
import classnames from 'classnames';
import { omit } from 'lodash';
import { Loading, NotFound, Clear, Search, DownArrow, UpArrow, TongyongJianTouYou } from './icons';
import { TongyongGuanbiXian } from '@sirius/icons';
import './style/index.scss';
const { SHOW_CHILD, SHOW_PARENT } = RcCascader;
const prefixCls = 'sirius-cascader-select';
const cascaderPrefixCls = 'sirius-cascader';
const Component = (props, ref) => {
    const { fetching, suffixIcon, showSearch, onFocus, onBlur, onDropdownVisibleChange, multiple, className, popupClassName, bordered, size } = props, rest = __rest(props, ["fetching", "suffixIcon", "showSearch", "onFocus", "onBlur", "onDropdownVisibleChange", "multiple", "className", "popupClassName", "bordered", "size"]);
    const [downArrow, setDownArrow] = useState(true);
    const [focus, setFocus] = useState(false);
    const [optOpen, setOptOpen] = useState(false);
    const restProps = omit(rest);
    const handleOnFocus = (event) => {
        setFocus(!onFocus);
        onFocus && onFocus(event);
    };
    const handleBlur = (event) => {
        setFocus(false);
        onBlur && onBlur(event);
    };
    useEffect(() => {
        setDownArrow(!optOpen);
    }, [optOpen]);
    const handleOnDropdownVisibleChange = (open) => {
        setOptOpen(open);
        onDropdownVisibleChange && onDropdownVisibleChange(open);
    };
    const highlightKeyword = (str, lowerKeyword, prefixCls) => {
        const cells = str
            .toLowerCase()
            .split(lowerKeyword)
            .reduce((list, cur, index) => (index === 0 ? [cur] : [...list, lowerKeyword, cur]), []);
        const fillCells = [];
        let start = 0;
        cells.forEach((cell, index) => {
            const end = start + cell.length;
            let originWorld = str.slice(start, end);
            start = end;
            if (index % 2 === 1) {
                originWorld = (React.createElement("span", { className: `${prefixCls}-menu-item-keyword`, key: `seperator-${index}` }, originWorld));
            }
            fillCells.push(originWorld);
        });
        return fillCells;
    };
    const defaultSearchRender = (inputValue, path, prefixCls, fieldNames) => {
        const optionList = [];
        const lower = inputValue.toLowerCase();
        path.forEach((node, index) => {
            if (index !== 0) {
                optionList.push(' / ');
            }
            let label = node[fieldNames.label];
            const type = typeof label;
            if (type === 'string' || type === 'number') {
                label = highlightKeyword(String(label), lower, prefixCls);
            }
            optionList.push(label);
        });
        return optionList;
    };
    const notFound = useMemo(() => {
        if (fetching)
            return (React.createElement("div", { className: `${cascaderPrefixCls}-menu-loading` },
                React.createElement(Loading, null)));
        else
            return React.createElement(NotFound, null);
    }, []);
    const renderSuffixIcon = useMemo(() => {
        if (suffixIcon)
            return suffixIcon;
        else
            return showSearch && focus ? React.createElement(Search, null) : downArrow ? React.createElement(DownArrow, null) : React.createElement(UpArrow, null);
    }, [showSearch, focus, downArrow]);
    const mergedShowSearch = useMemo(() => {
        if (!showSearch) {
            return showSearch;
        }
        let searchConfig = {
            render: defaultSearchRender,
        };
        if (typeof showSearch === 'object') {
            searchConfig = Object.assign(Object.assign({}, searchConfig), showSearch);
        }
        return searchConfig;
    }, [showSearch]);
    return (React.createElement(RcCascader, Object.assign({ ref: ref, prefixCls: prefixCls, className: classnames(className, cascaderPrefixCls, {
            [`${prefixCls}-mn`]: size === 'mini',
            [`${prefixCls}-sm`]: size === 'small',
            [`${prefixCls}-lg`]: size === 'large',
            [`${prefixCls}-borderless`]: !bordered,
        }) }, restProps, { inputIcon: renderSuffixIcon, clearIcon: React.createElement(Clear, null), removeIcon: React.createElement(TongyongGuanbiXian, { className: `${cascaderPrefixCls}-removeIcon` }), expandTrigger: props.expandTrigger || 'hover', onFocus: handleOnFocus, onBlur: handleBlur, onDropdownVisibleChange: handleOnDropdownVisibleChange, expandIcon: React.createElement(TongyongJianTouYou, null), dropdownPrefixCls: cascaderPrefixCls, dropdownClassName: classnames(popupClassName, `${cascaderPrefixCls}-dropdown`, {
            [`${cascaderPrefixCls}-single`]: !multiple,
            [`${cascaderPrefixCls}-multiple`]: multiple,
        }), showSearch: mergedShowSearch, checkable: multiple, notFoundContent: notFound })));
};
const Cascader = React.forwardRef(Component);
Cascader.defaultProps = {
    bordered: true,
};
Cascader.SHOW_PARENT = SHOW_PARENT;
Cascader.SHOW_CHILD = SHOW_CHILD;
export default Cascader;
